// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import GridsGridLineContainer from '../../containers/grid/GridsGridLineContainer';
import type { GridsCheckType } from '../../types';

const Wrap = styled.div`
  margin: 0.6em 0;
`;

type GridsGridProps = {
  className?: string;
  matches: Array<number> | null;
  selection: string;
  resultSelection?: string;
  onCheckBox?: (matchIndex: number, checkType: GridsCheckType) => void;
  isSystemCompact?: boolean;
  isBasket?: boolean;
  hideInfo?: boolean;
  isClosedPool?: boolean;
};

const GridsGrid = ({
  className,
  matches,
  selection,
  resultSelection,
  onCheckBox,
  isSystemCompact = false,
  isBasket = false,
  hideInfo = false,
  isClosedPool = false,
}: GridsGridProps) => {
  return (
    <Wrap className={className}>
      {matches?.map((matchId, matchIndex) => (
        <GridsGridLineContainer
          key={matchId}
          matchId={matchId}
          matchIndex={matchIndex}
          isClosedPool={isClosedPool}
          hideInfo={hideInfo}
          isBasket={isBasket}
          isSystemCompact={isSystemCompact}
          selection={selection}
          resultSelection={resultSelection}
          onCheckBox={onCheckBox}
        />
      ))}
    </Wrap>
  );
};

export default GridsGrid;
